import { AxiosPromise } from 'axios';
import { IGetTreeCode, IGetTreeCodes, IGetTreeSubcode, IGetTreeSubcodes, ITreeCodeReq, ITreeSubcode, ITreeCodeSeqReq, IAddTreeSubCodeReq, ITreeSubCodeReq } from '../models/treeCodes.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/treecodes';

//TreeCode 전체 조회
export const getTotalTreeCodes = (): AxiosPromise<IGetTreeSubcodes> => {
  return axios.get(uri);
}

export const getCode = (commonCode: string): AxiosPromise<IGetTreeCode> => {
  return axios.get(`${uri}/${commonCode}`);
}

export const getCodes = (): AxiosPromise<IGetTreeCodes> => {
  return axios.get(`${uri}/list`);
}

export const getSubcode = (commonCode: string, id: string): AxiosPromise<IGetTreeSubcode> => {
  return axios.get(`${uri}/${commonCode}/${id}`);
}

export const getSubcodes = (commonCode: string, param: ITreeSubCodeReq): AxiosPromise<IGetTreeSubcodes> => {
  const qsParam = QueryString.stringify(param);
  return axios.get(`${uri}/${commonCode}/list?${qsParam}`);
}

export const createCode = (data: ITreeCodeReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const createSubcode = (commonCode: string, data: IAddTreeSubCodeReq): AxiosPromise => {
  return axios.post(`${uri}/${commonCode}`, data);
};

export const updateCode = (commonCode: string, data: ITreeCodeReq): AxiosPromise => {
  return axios.put(`${uri}/${commonCode}`, data);
};

export const updateSubcode = (commonCode: string, detailCode: number, data: IAddTreeSubCodeReq): AxiosPromise => {
  return axios.put(`${uri}/${commonCode}/${detailCode}`, data);
};

export const updateSubcodeSeq = (commonCode: string, data: ITreeCodeSeqReq[]): AxiosPromise => {
  return axios.put(`${uri}/${commonCode}/sequence`, data);
};
